module.exports = __webpack_public_path__ + "img/testimonial-dark-02.886c5b36.jpg";